import React, { StrictMode } from 'react';

import { App } from 'routes/App';
import { Matryoshka } from '@clover-util/matryoshka';
import { ScriptRegistryProvider } from '@clover-util/script-registry';
import { WindowSizeProvider } from 'hooks/breakpoints';
import { CartPreviewProvider } from 'hooks/context/CartPreview';
import { CloverReactQueryProvider } from 'hooks/context/CloverReactQueryProvider';

export const Root = () => (
  <Matryoshka
    wrappers={[
      StrictMode,
      ScriptRegistryProvider,
      CloverReactQueryProvider,
      WindowSizeProvider,
      CartPreviewProvider,
      App
    ]}
  />
);
